import { memo } from 'react'
import { Box, TableContainer } from '@mui/material'
import { Order } from '../../proto/generated/order'
import { OrdersNavButtonsDetailed } from '../postionsWidget'
import OpenOrdersTable from './OpenOrdersTable'
import EmptyView from '../postionsWidget/EmptyView'

export type OrdersTableScrollAreaProps = {
    orders: Order[]
    tabType: OrdersNavButtonsDetailed
    emptyText: string
    hideOrderStatus?: boolean
    variant?: 'sidebar' | 'widget'
}

const OrdersTableScrollArea: React.FC<OrdersTableScrollAreaProps> = ({
    orders,
    tabType,
    emptyText,
    hideOrderStatus = false,
    variant = 'sidebar',
}) => {
    if (orders.length === 0) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    py: 0,
                }}
            >
                <EmptyView text={emptyText} />
            </Box>
        )
    }

    if (variant === 'widget') {
        return (
            <TableContainer sx={{ display: 'flex', flexDirection: 'column', flex: 1, overflowX: 'auto' }}>
                <OpenOrdersTable orders={orders} tabType={tabType} stickyHeader hideOrderStatus={hideOrderStatus} />
            </TableContainer>
        )
    }

    return (
        <TableContainer>
            <OpenOrdersTable orders={orders} tabType={tabType} hideOrderStatus={hideOrderStatus} />
        </TableContainer>
    )
}

export default memo(
    OrdersTableScrollArea,
    (prev, next) =>
        prev.orders === next.orders &&
        prev.tabType === next.tabType &&
        prev.emptyText === next.emptyText &&
        prev.hideOrderStatus === next.hideOrderStatus &&
        prev.variant === next.variant
)
